import { BoardParticipant, Partner } from 'types';

export const getSelectablePartners = (
  partners: Partner[],
  actualPartner: BoardParticipant
): Partner[] =>
  partners.filter(
    (partner) => partner['_id'] === actualPartner?.representative
  ) || [];
